import { FNode } from '@spazious/dollhouse-fsetup';
import { useTranslate } from '@spazious/dollhouse-i18n';
import { useStore } from '@spazious/dollhouse-store';
import { useEventCallback } from '@spazious/react-hooks';

import { useEvents } from '../components/index.js';
import { validateNodesPlacement } from '../utils/index.js';

export const useNodesPlacementValidator = (nodes: FNode[] = []) => {
  const navMeshQuery = useStore(({ world }) => world.navMeshQuery);
  const events = useEvents();
  const translate = useTranslate();

  const validator = useEventCallback((currentNodes: FNode[] = []) => {
    const nodesToValidate = currentNodes.length ? currentNodes : nodes;
    const { valid, error } = validateNodesPlacement(nodesToValidate, navMeshQuery);
    if (!valid) {
      events.emit('error', translate(error ?? ''));
    }
    return valid;
  });

  return { validator };
};
